<script setup>
import DarkModeStore from '@o/store'
const { options, isLocked } = DarkModeStore()
import { Preview, Range, Button } from '@components'
import ColorFilters from './ColorFilters.vue'
</script>
<template>
   <Card>
    <Heading bold> 
      <Row inline class="items-center"><Row locked :ProBadge="false">Adjust your automatic color filter</Row> <ProBadge /></Row>
      <Hints locked>Adjust the your automatic color for dark mode color scheme</Hints>
   </Heading>
    <div class="h-0.5 w-full bg-gray-100 my-3"></div>
    <ColorFilters /> 
   </Card>
</template>